import { z } from 'zod'

/**
 * Standard pagination metadata returned alongside paginated `data` arrays.
 */
export const PageResponseSchema = z.object({
  limit: z.number(),
  offset: z.number(),
  totalCount: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
})
export type PageResponse = z.infer<typeof PageResponseSchema>

export { getPageObject } from '@mntn/zod'
